import apiClient from "@/helpers/http-common";

export default {
    async fetchSectionLinks(id) {
        return await apiClient.get("/api/section-listing/" + id);
    }
};
